export const GET_CURRENT_EDOK_YEAR_SUCCESS = 'GET_CURRENT_EDOK_YEAR_SUCCESS';

export const getCurrentEdokYearSuccess = ({ year }) => ({
    type: GET_CURRENT_EDOK_YEAR_SUCCESS,
    payload: {
        year,
    }
});
